import Header from './Header'
import Sidebar from './Sidebar'
import Footer from './Footer'
import Dropdown from './Dropdown'
import Title from './Title'
import SidebarRes from './SidebarRes'
import Spinner from './Spinner'

export {
    Header,
    Sidebar,
    Footer,
    Dropdown,
    Title,
    SidebarRes,
    Spinner
}


// WEBPACK FOOTER //
// ./src/component/index.js